var React = require('react');

function ArrowCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"23","transform":"rotate(-180 24 24)","stroke":"#00122B","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M27 33L18 24L27 15","stroke":"#00122B","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowCircleInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ArrowCircleInline;

ArrowCircleInline.default = ArrowCircleInline;
